// const API_ENDPOINT_V1 = 'http://localhost:8080/api';
// const SOCKET_ENDPOINT = 'http://localhost:8080';
const SOCKET_ENDPOINT = 'https://di-server-v2.pulsarai.ge';
const API_ENDPOINT_V1 = 'https://di-server-v2.pulsarai.ge/api';

export { API_ENDPOINT_V1 };
